import { Button, Card, Form, Space } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BUYER_INQUIRY_LIST_ENDPOINT, CM_REPORT_DATA } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import HandleNotification from "../../../common/Notification";
import Header from "../../Common/Header";
import BuyerInquiryForm from "./BuyerInquiryForm";

const UpdateBuyerInquiry = (props) => {
  // Props
  const { editMode, viewMode } = props;

  // States
  const [documents, setDocuments] = useState([]);
  const [editInfo, setEditInfo] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [CMInfo, setCMInfo] = useState(null);
  const [users, setUsers] = useState([]);
  const [styles, setStyles] = useState([]);
  const [buyingOffice, setBuyingOffice] = useState([]);
  const [buyer, setBuyer] = useState([]);
  const [garmentCategoryList, setGarmentCategoryList] = useState([]);
  const [garmentTypeList, setGarmentTypeList] = useState([]);
  const [garmentForList, setGarmentForList] = useState([]);
  const [brand, setBrand] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Antd
  const [form] = Form.useForm();
  const breakeven_cm_watch = Form.useWatch("breakeven_cm", form);
  const style_id_watch = Form.useWatch("style_id", form);
  const negotiated_cm_watch = Form.useWatch("negotiated_cm", form);
  const expected_margin_watch = Form.useWatch("expected_margin", form);
  // Others
  const navigate = useNavigate();
  const { inquiryId } = useParams();

  useEffect(() => {
    if (form) {
      const breakeven = Number(breakeven_cm_watch);
      if (
        breakeven_cm_watch !== undefined &&
        breakeven_cm_watch !== null &&
        !isNaN(breakeven)
      ) {
        const profitMargin = Number(expected_margin_watch || 0);
        const marginAmount = isNaN(profitMargin) ? 0 : (breakeven * profitMargin) / 100;
        const totalExpectedMargin = breakeven + marginAmount;
        const quotedCm = isNaN(totalExpectedMargin)
          ? null
          : Number(parseFloat(totalExpectedMargin).toFixed(2));

        form.setFieldsValue({
          total_expected_margin: isNaN(totalExpectedMargin)
            ? null
            : totalExpectedMargin,
          cgl_target: quotedCm,
        });
      }
    }
  }, [breakeven_cm_watch, expected_margin_watch, form]);

  useEffect(() => {
    // When breakeven or negotiated CM changes
    if (form) {
      // Previous logic retained (commented out as per requirement):
      // const cgl_target_calc =
      //   Number(breakeven_cm_watch) + Number(expected_margin_watch);
      // const difference_calc =
      //   Number(cgl_target_calc) - Number(buyer_target_watch);
      // const operational_profit_calc =
      //   Number(buyer_target_watch) - Number(breakeven_cm_watch);
      // form.setFieldsValue({
      //   difference: difference_calc || null,
      //   operational_profit: operational_profit_calc || null,
      // });

      // const total_expected_margin_calc =
      //   (Number(breakeven_cm_watch) * Number(expected_margin_watch)) / 100 +
      //   Number(breakeven_cm_watch);
      const differenceValue =
        negotiated_cm_watch !== undefined &&
          negotiated_cm_watch !== null &&
          breakeven_cm_watch !== undefined &&
          breakeven_cm_watch !== null
          ? Number(negotiated_cm_watch) - Number(breakeven_cm_watch)
          : null;

      form.setFieldsValue({
        difference: differenceValue,
        // cgl_target:
        //   editInfo?.quoted_cm !== undefined && editInfo?.quoted_cm !== null
        //     ? editInfo?.quoted_cm
        //     : cgl_target_calc || cgl_target_calc === 0
        //     ? cgl_target_calc
        //     : null,
        // difference: difference_calc || null,
        operational_profit: differenceValue,
      });
    }
  }, [form, breakeven_cm_watch, negotiated_cm_watch]);

  const getSelectedInquiryInfo = async (id) => {
    const query = `${BUYER_INQUIRY_LIST_ENDPOINT}/${id}/edit`;
    const response = await getData(query);

    if (response && response?.data?.code === 200) {
      const style_document = Array.isArray(response?.data?.data?.style_inquiry_map?.style_info?.style_document)
        ? response?.data?.data?.style_inquiry_map?.style_info?.style_document
        : [];
      setEditInfo(response?.data?.data);
      setFileData(response?.data?.data?.documents);

      setDocuments(
        style_document?.map((itm) => ({
          id: itm?.id,
          name: itm?.document_name,
          path: itm?.document,
          attachment_type: itm?.attachment_type,
          reference_no: itm?.reference_no,
        })),
      );
    } else {
      HandleNotification("error", "Error!", response?.message || "Failed to get inquiry data");
    }
  };

  const getSelectedCMInfo = async (id) => {
    const query = `${CM_REPORT_DATA}/${id}`;
    const response = await getData(query);

    if (response && response?.data?.code === 200) {
      const CMData = response?.data?.data;
      setCMInfo(CMData);
      const total = Number(CMData?.cm_info?.breakeven_cm || 0) + 8000;
      form.setFieldsValue({
        breakeven_cm:
          CMData?.cm_info?.breakeven_cm || CMData?.cm_info?.breakeven_cm === 0 ? CMData?.cm_info?.breakeven_cm : null,
      });
      return CMData;
    } else {
      HandleNotification("error", "", "CM Info Error!", response?.data?.message || "Failed to get CM data");
    }
  };

  useEffect(() => {
    if (inquiryId) {
      getSelectedInquiryInfo(inquiryId);
      getSelectedCMInfo(inquiryId);
    }
  }, [inquiryId]);

  useEffect(() => {
    const getObStatus = () => {
      if (CMInfo?.ob_info) {
        if (CMInfo?.ob_info?.standard_minute) {
          return "Created";
        } else {
          return "Pending";
        }
      } else {
        return "Pending";
      }
    };

    if (
      editInfo?.received_by_info?.name &&
      editInfo?.received_by &&
      !users.some((item) => item.id === editInfo?.received_by)
    ) {
      setUsers((prev) => [
        {
          id: editInfo?.received_by,
          name: editInfo?.received_by_info?.name,
        },
        ...prev,
      ]);
    }

    if (
      editInfo?.style_inquiry_map?.style_info?.id &&
      !styles.some((item) => item.id === editInfo?.style_inquiry_map?.style_info?.id)
    ) {
      setStyles((prev) => [
        {
          id: editInfo?.style_inquiry_map?.style_info?.id,
          style_no: editInfo?.style_inquiry_map?.style_info?.style_no,
        },
        ...prev,
      ]);
    }

    if (
      editInfo?.buying_office_info?.id &&
      !buyingOffice.some((item) => item.id === editInfo?.buying_office_info?.id)
    ) {
      setBuyingOffice((prev) => [
        {
          id: editInfo?.buying_office_info?.id,
          name: editInfo?.buying_office_info?.name,
        },
        ...prev,
      ]);
    }

    if (editInfo?.buyer_info?.id && !buyer.some((item) => item.id === editInfo?.buyer_info?.id)) {
      setBuyer((prev) => [
        {
          id: editInfo?.buyer_info?.id,
          name: editInfo?.buyer_info?.name,
        },
        ...prev,
      ]);
    }

    if (
      editInfo?.garment_category_info?.id &&
      !garmentCategoryList.some((item) => item.id === editInfo?.garment_category_info?.id)
    ) {
      setGarmentCategoryList((prev) => [
        {
          id: editInfo?.garment_category_info?.id,
          name: editInfo?.garment_category_info?.name,
        },
        ...prev,
      ]);
    }

    if (
      editInfo?.garment_type_info?.id &&
      !garmentTypeList.some((item) => item.id === editInfo?.garment_type_info?.id)
    ) {
      setGarmentTypeList((prev) => [
        {
          id: editInfo?.garment_type_info?.id,
          name: editInfo?.garment_type_info?.name,
        },
        ...prev,
      ]);
    }

    if (editInfo?.garment_for_info?.id && !garmentForList.some((item) => item.id === editInfo?.garment_for_info?.id)) {
      setGarmentForList((prev) => [
        {
          id: editInfo?.garment_for_info?.id,
          name: editInfo?.garment_for_info?.name,
        },
        ...prev,
      ]);
    }

    if (editInfo?.brand_info?.id && !brand.some((item) => item.id === editInfo?.brand_info?.id)) {
      setBrand((prev) => [
        {
          id: editInfo?.brand_info?.id,
          name: editInfo?.brand_info?.name,
        },
        ...prev,
      ]);
    }

    if (editInfo?.country_info?.id && !countryList.some((item) => item.id === editInfo?.country_info?.id)) {
      setCountryList((prev) => [
        {
          id: editInfo?.country_info?.id,
          name: editInfo?.country_info?.name,
          status: editInfo?.country_info?.status,
        },
        ...prev,
      ]);
    }

    const expected_margin =
      editInfo?.expected_margin === 0 ||
        editInfo?.expected_margin === null ||
        editInfo?.expected_margin === undefined
        ? null
        : Math.trunc(Number(editInfo.expected_margin));

    let total_expected_margin = editInfo?.total_expected_margin;
    if (
      breakeven_cm_watch !== undefined &&
      breakeven_cm_watch !== null &&
      !isNaN(Number(breakeven_cm_watch))
    ) {
      const breakeven = Number(breakeven_cm_watch);
      const profitMargin = Number(expected_margin || 0);
      const marginAmount = isNaN(profitMargin) ? 0 : (breakeven * profitMargin) / 100;
      total_expected_margin = breakeven + marginAmount;
    }

    const cgl_target =
      total_expected_margin !== undefined &&
        total_expected_margin !== null &&
        !isNaN(Number(total_expected_margin))
        ? Number(parseFloat(total_expected_margin).toFixed(2))
        : null;

    form.setFieldsValue({
      inquiry_no: editInfo?.inquiry_no,
      style_no: editInfo?.style_inquiry_map?.style_info?.style_no,
      received_date: editInfo?.received_date ? moment(editInfo?.received_date) : null,
      received_by: editInfo?.received_by,
      received_by_name: editInfo?.received_by_info?.name,
      style_id: editInfo?.style_inquiry_map?.style_info?.id,
      buying_office_id: editInfo?.buying_office_info?.id,
      buying_office_name: editInfo?.buying_office_info?.name,
      buyer_id: editInfo?.buyer_info?.id,
      buyer_short_name: editInfo?.buyer_info?.short_name,
      buyer_name: editInfo?.buyer_info?.name,
      brand_id: editInfo?.brand_info?.id,
      brand_name: editInfo?.brand_info?.name,
      garment_category_id: editInfo?.garment_category_info?.id,
      garment_type_id: editInfo?.garment_type_info?.id,
      garment_for_id: editInfo?.garment_for_info?.id,
      inquiry_status: editInfo?.inquiry_status,
      expected_order_quantity: editInfo?.expected_order_quantity,
      expected_delivery_date: editInfo?.expected_delivery_date ? moment(editInfo?.expected_delivery_date) : null,
      production_month_from: editInfo?.production_month_from ? moment(editInfo?.production_month_from) : null,
      production_month_to: editInfo?.production_month_to ? moment(editInfo?.production_month_to) : null,
      description: editInfo?.description,
      season:
        editInfo?.season !== null && editInfo?.season !== undefined && editInfo?.season !== ""
          ? Number(editInfo.season)
          : null,
      size_range: editInfo?.size_range,
      ob_status: getObStatus(),
      total_sam: CMInfo?.ob_info?.standard_minute,
      no_of_workers: CMInfo?.ob_info?.manpower_per_line,
      no_of_hour: CMInfo?.ob_info?.working_hour_per_day,
      required_efficiency: CMInfo?.ob_info?.factory_efficiency,
      per_hour_target: CMInfo?.ob_info?.production_per_hours,
      order_confirmations: editInfo?.order_confirmation?.map((item) => {
        return {
          id: item?.id || 0,
          inquiry_reason_id: item?.inquiry_reason_id || null,
          inquiry_remark_id: item?.inquiry_remark_id || null,
          is_delete: item?.is_delete || 0,
        };
      }),
      order_status: editInfo?.order_status,
      buyer_target: editInfo?.buyer_target,
      expected_margin: expected_margin,
      total_expected_margin: isNaN(Number(total_expected_margin))
        ? null
        : total_expected_margin,
      negotiated_cm: editInfo?.negotiated_cm,
      cgl_target: cgl_target,
      sub_contract_factory_id: editInfo?.sub_contract_factory_id,
      subcontract_status: editInfo?.subcontract_status,
      address: editInfo?.factory_info ? editInfo?.factory_info?.address : null,
      order_type: editInfo?.order_type,
      order_channel: editInfo?.order_channel,
      fabric_content: editInfo?.fabric_content,
      fob: editInfo?.fob,
      capacity_availability: editInfo?.capacity_availability,
      country_id: editInfo?.country_id,
      embroidery: editInfo?.embroidery === "Yes" ? 1 : 0,
      printing: editInfo?.printing === "Yes" ? 1 : 0,
      washing: editInfo?.washing === "Yes" ? 1 : 0,
      smoking: editInfo?.smoking === "Yes" ? 1 : 0,
      pintuck: editInfo?.pintuck === "Yes" ? 1 : 0,
      snap_button: editInfo?.snap_button === "Yes" ? 1 : 0,
      is_multiple_style: editInfo?.is_multiple_style === "Yes" ? 1 : 0,
      fabric_status: editInfo?.fabric_status,
      trim_status: editInfo?.trim_status,
      accessories_status: editInfo?.accessories_status,
      reference_id: editInfo?.reference_id,
      extra_percent: Number(editInfo?.extra_percent).toFixed(2) || 0,
      order_quantity: editInfo?.order_quantity,
    });
  }, [inquiryId, editInfo, form, breakeven_cm_watch, CMInfo]);

  const discartForm = () => {
    navigate("/merchandising/buyer-inquiry");
  };

  const addBuyerInquiry = () => {
    form.submit();
  };

  const onCopyStyle = () => {
    window.open(`/merchandising/add-style-from-inquiry/${editInfo?.id}`);
  };

  const ActionUI = () => {
    return (
      <Space>
        <Button size="small" key={1} danger onClick={() => discartForm()}>
          Discard
        </Button>

        {!style_id_watch && (
          <Button size="small" key={1} onClick={() => onCopyStyle()} disabled={viewMode}>
            Create Style
          </Button>
        )}

        <Button
          size="small"
          key={2}
          type="primary"
          onClick={() => addBuyerInquiry()}
          hidden={viewMode}
          loading={isLoading}
          disabled={editInfo?.is_editable === "Yes" ? false : true}
        >
          Edit Buyer Inquiry
        </Button>
      </Space>
    );
  };

  return (
    <>
      <div className="sticky-form-header">
        <Card style={{ width: "100%" }}>
          <Header
            disableAffix
            title={`${viewMode ? "View" : "Edit"} Buyer Inquiry`}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={<ActionUI />}
          />
        </Card>
      </div>

      <div className="form-content-body">
        <BuyerInquiryForm
        form={form}
        isEdit={true}
        editMode={editMode}
        viewMode={viewMode}
        editInfo={editInfo}
        fileData={fileData}
        CMInfo={CMInfo}
        users={users}
        setUsers={setUsers}
        styles={styles}
        setStyles={setStyles}
        buyingOffice={buyingOffice}
        setBuyingOffice={setBuyingOffice}
        buyer={buyer}
        setBuyer={setBuyer}
        garmentCategoryList={garmentCategoryList}
        setGarmentCategoryList={setGarmentCategoryList}
        garmentTypeList={garmentTypeList}
        setGarmentTypeList={setGarmentTypeList}
        garmentForList={garmentForList}
        setGarmentForList={setGarmentForList}
        brand={brand}
        setBrand={setBrand}
        countryList={countryList}
        setCountryList={setCountryList}
        documents={documents}
        setDocuments={setDocuments}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      </div>
    </>
  );
};

export default UpdateBuyerInquiry;
